import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Agriculture = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.185 33.427a3.122 3.122 0 0 1-3.106 3.107 3.122 3.122 0 0 1-3.107-3.107 3.122 3.122 0 0 1 3.107-3.107 3.122 3.122 0 0 1 3.106 3.107ZM9.721 22.002A9.667 9.667 0 0 0 0 31.723a9.667 9.667 0 0 0 9.721 9.721 9.667 9.667 0 0 0 9.721-9.72 9.667 9.667 0 0 0-9.72-9.722Zm0 17.538a7.87 7.87 0 0 1-7.917-7.917c0-4.31 3.508-7.917 7.917-7.917a7.87 7.87 0 0 1 7.918 7.917A7.87 7.87 0 0 1 9.72 39.54Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.828 31.723a3.122 3.122 0 0 1-3.107 3.107 3.122 3.122 0 0 1-3.107-3.107 3.122 3.122 0 0 1 3.107-3.107 3.122 3.122 0 0 1 3.107 3.107ZM39.185 33.427a3.122 3.122 0 0 1-3.106 3.107 3.122 3.122 0 0 1-3.107-3.107 3.122 3.122 0 0 1 3.107-3.107 3.122 3.122 0 0 1 3.106 3.107Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.185 33.427a3.122 3.122 0 0 1-3.106 3.107 3.122 3.122 0 0 1-3.107-3.107 3.122 3.122 0 0 1 3.107-3.107 3.122 3.122 0 0 1 3.106 3.107Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M39.586 26.211v-9.22c0-.501-.4-.902-.902-.902H32.27V8.573c0-.501-.4-.902-.902-.902h-2.906c-.501 0-.902.4-.902.902 0 .5.401.902.902.902h2.005v6.614h-6.415L20.846 3.261a.963.963 0 0 0-.902-.701H5.412c-.401 0-.802.3-.902.701L1.804 14.285c-.1.501.2 1.002.701 1.103.502.1 1.003-.2 1.103-.702L6.113 4.364h13.129l3.207 12.828c.1.4.501.701.902.701h7.216v5.111c0 .501.4.902.902.902.5 0 .902-.4.902-.902v-5.111h5.512v7.617c-.501-.1-1.103-.2-1.704-.2-4.41 0-8.018 3.607-8.018 8.017v.802h-4.309v-2.506c0-7.817-6.314-14.03-14.03-14.03-3.608 0-6.916 1.402-9.421 3.607-.401.3-.401.902-.1 1.303.3.401.902.401 1.302.1 2.205-1.904 5.011-3.107 8.118-3.107 6.715 0 12.227 5.513 12.227 12.227v3.408c0 .5.4.902.902.902h5.612c1.102 3.106 4.11 5.411 7.516 5.411 4.41 0 8.018-3.607 8.018-8.017.1-3.207-1.704-5.913-4.41-7.216Zm-3.507 13.73a6.501 6.501 0 0 1-6.515-6.514 6.501 6.501 0 0 1 6.515-6.514 6.501 6.501 0 0 1 6.514 6.514 6.501 6.501 0 0 1-6.514 6.514Z"
  })));
});
Agriculture.displayName = 'Agriculture';
Agriculture.defaultProps = {
  'aria-label': 'Agriculture'
};
export default Agriculture;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/Agriculture.js
// module id = 3597
// module chunks = 11